import { gql } from '@apollo/client'

export const DELETE_APPOINTMENT_RECURRENCE = gql`
  mutation deleteEhrAppointmentRecurrence($baseStartDate: ISO8601DateTime) {
    deleteEhrAppointmentRecurrence(baseStartDate: $baseStartDate) {
      success
    }
  }
`
